
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ClientCompanyRemoveMemberRequest,
  ClientCompanySendInvitationRequest,
  ClientCompanySettingsContextResource,
  ClientCompanyTeamSearchRequest,
  ClientCompanyUpdateMemberRoleRequest,
  ClientTeamSettingsResource,
  ClientTeamSettingsUpdateRequest,
  CustomerUserResource,
  GetClientTeamSettingsRequest,
  PageClientCompanyInvitationResource,
  PageClientCompanyMemberResource,
  ResendTeamInvitationRequest,
} from '../models';
import {
    ClientCompanyRemoveMemberRequestFromJSON,
    ClientCompanyRemoveMemberRequestToJSON,
    ClientCompanySendInvitationRequestFromJSON,
    ClientCompanySendInvitationRequestToJSON,
    ClientCompanySettingsContextResourceFromJSON,
    ClientCompanySettingsContextResourceToJSON,
    ClientCompanyTeamSearchRequestFromJSON,
    ClientCompanyTeamSearchRequestToJSON,
    ClientCompanyUpdateMemberRoleRequestFromJSON,
    ClientCompanyUpdateMemberRoleRequestToJSON,
    ClientTeamSettingsResourceFromJSON,
    ClientTeamSettingsResourceToJSON,
    ClientTeamSettingsUpdateRequestFromJSON,
    ClientTeamSettingsUpdateRequestToJSON,
    CustomerUserResourceFromJSON,
    CustomerUserResourceToJSON,
    GetClientTeamSettingsRequestFromJSON,
    GetClientTeamSettingsRequestToJSON,
    PageClientCompanyInvitationResourceFromJSON,
    PageClientCompanyInvitationResourceToJSON,
    PageClientCompanyMemberResourceFromJSON,
    PageClientCompanyMemberResourceToJSON,
    ResendTeamInvitationRequestFromJSON,
    ResendTeamInvitationRequestToJSON,
} from '../models';

export interface AttributeRoleToTeamMemberRequest {
    memberId: string;
    clientCompanyUpdateMemberRoleRequest: ClientCompanyUpdateMemberRoleRequest;
}

export interface GetClientTeamMembersRequest {
    clientCompanyTeamSearchRequest: ClientCompanyTeamSearchRequest;
}

export interface GetSettingsContextRequest {
    companyId: string;
}

export interface GetTeamInvitationsRequest {
    clientCompanyTeamSearchRequest: ClientCompanyTeamSearchRequest;
}

export interface GetTeamSettingsRequest {
    getClientTeamSettingsRequest: GetClientTeamSettingsRequest;
}

export interface RemoveClientTeamMemberRequest {
    memberId: string;
    clientCompanyRemoveMemberRequest: ClientCompanyRemoveMemberRequest;
}

export interface ResendTeamInvitationOperationRequest {
    invitationId: string;
    resendTeamInvitationRequest: ResendTeamInvitationRequest;
}

export interface SendTeamInvitationRequest {
    clientCompanySendInvitationRequest: ClientCompanySendInvitationRequest;
}

export interface UpdateTeamSettingsRequest {
    clientTeamSettingsUpdateRequest: ClientTeamSettingsUpdateRequest;
}

/**
 * 
 */
export class ClientSettingsApi extends runtime.BaseAPI {

    /**
     * PUT /client-settings/api/team/members/{memberId}/role
          */
    async attributeRoleToTeamMemberRaw(requestParameters: AttributeRoleToTeamMemberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling attributeRoleToTeamMember().'
            );
        }

        if (requestParameters['clientCompanyUpdateMemberRoleRequest'] == null) {
            throw new runtime.RequiredError(
                'clientCompanyUpdateMemberRoleRequest',
                'Required parameter "clientCompanyUpdateMemberRoleRequest" was null or undefined when calling attributeRoleToTeamMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/team/members/{memberId}/role`.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ClientCompanyUpdateMemberRoleRequestToJSON(requestParameters['clientCompanyUpdateMemberRoleRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * PUT /client-settings/api/team/members/{memberId}/role
          */
    async attributeRoleToTeamMember(memberId: string, clientCompanyUpdateMemberRoleRequest: ClientCompanyUpdateMemberRoleRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.attributeRoleToTeamMemberRaw({ memberId: memberId, clientCompanyUpdateMemberRoleRequest: clientCompanyUpdateMemberRoleRequest }, initOverrides);
    }

    /**
     * POST /client-settings/api/team/members
          */
    async getClientTeamMembersRaw(requestParameters: GetClientTeamMembersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PageClientCompanyMemberResource>> {
        if (requestParameters['clientCompanyTeamSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'clientCompanyTeamSearchRequest',
                'Required parameter "clientCompanyTeamSearchRequest" was null or undefined when calling getClientTeamMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<PageClientCompanyMemberResource>({
            path: `/client-settings/api/team/members`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientCompanyTeamSearchRequestToJSON(requestParameters['clientCompanyTeamSearchRequest']),
        }, initOverrides);

        if (response._data) { response._data=PageClientCompanyMemberResourceFromJSON(response._data); }
        return response;
    }

    /**
     * POST /client-settings/api/team/members
          */
    async getClientTeamMembers(clientCompanyTeamSearchRequest: ClientCompanyTeamSearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PageClientCompanyMemberResource> {
        const response = await this.getClientTeamMembersRaw({ clientCompanyTeamSearchRequest: clientCompanyTeamSearchRequest }, initOverrides);
        return response._data;
    }

    /**
     * GET /client-settings/api/team/user
          */
    async getCustomerUserRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CustomerUserResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CustomerUserResource>({
            path: `/client-settings/api/team/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CustomerUserResourceFromJSON(response._data); }
        return response;
    }

    /**
     * GET /client-settings/api/team/user
          */
    async getCustomerUser(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CustomerUserResource> {
        const response = await this.getCustomerUserRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getSettingsContextRaw(requestParameters: GetSettingsContextRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientCompanySettingsContextResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getSettingsContext().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientCompanySettingsContextResource>({
            path: `/client-settings/api/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientCompanySettingsContextResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getSettingsContext(companyId: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientCompanySettingsContextResource> {
        const response = await this.getSettingsContextRaw({ companyId: companyId }, initOverrides);
        return response._data;
    }

    /**
     * POST /client-settings/api/team/invitations
          */
    async getTeamInvitationsRaw(requestParameters: GetTeamInvitationsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<PageClientCompanyInvitationResource>> {
        if (requestParameters['clientCompanyTeamSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'clientCompanyTeamSearchRequest',
                'Required parameter "clientCompanyTeamSearchRequest" was null or undefined when calling getTeamInvitations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<PageClientCompanyInvitationResource>({
            path: `/client-settings/api/team/invitations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientCompanyTeamSearchRequestToJSON(requestParameters['clientCompanyTeamSearchRequest']),
        }, initOverrides);

        if (response._data) { response._data=PageClientCompanyInvitationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * POST /client-settings/api/team/invitations
          */
    async getTeamInvitations(clientCompanyTeamSearchRequest: ClientCompanyTeamSearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<PageClientCompanyInvitationResource> {
        const response = await this.getTeamInvitationsRaw({ clientCompanyTeamSearchRequest: clientCompanyTeamSearchRequest }, initOverrides);
        return response._data;
    }

    /**
          */
    async getTeamSettingsRaw(requestParameters: GetTeamSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientTeamSettingsResource>> {
        if (requestParameters['getClientTeamSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'getClientTeamSettingsRequest',
                'Required parameter "getClientTeamSettingsRequest" was null or undefined when calling getTeamSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ClientTeamSettingsResource>({
            path: `/client-settings/api/team/settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetClientTeamSettingsRequestToJSON(requestParameters['getClientTeamSettingsRequest']),
        }, initOverrides);

        if (response._data) { response._data=ClientTeamSettingsResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getTeamSettings(getClientTeamSettingsRequest: GetClientTeamSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientTeamSettingsResource> {
        const response = await this.getTeamSettingsRaw({ getClientTeamSettingsRequest: getClientTeamSettingsRequest }, initOverrides);
        return response._data;
    }

    /**
     * POST /client-settings/api/team/members/{memberId}/remove
          */
    async removeClientTeamMemberRaw(requestParameters: RemoveClientTeamMemberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling removeClientTeamMember().'
            );
        }

        if (requestParameters['clientCompanyRemoveMemberRequest'] == null) {
            throw new runtime.RequiredError(
                'clientCompanyRemoveMemberRequest',
                'Required parameter "clientCompanyRemoveMemberRequest" was null or undefined when calling removeClientTeamMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/team/members/{memberId}/remove`.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientCompanyRemoveMemberRequestToJSON(requestParameters['clientCompanyRemoveMemberRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * POST /client-settings/api/team/members/{memberId}/remove
          */
    async removeClientTeamMember(memberId: string, clientCompanyRemoveMemberRequest: ClientCompanyRemoveMemberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeClientTeamMemberRaw({ memberId: memberId, clientCompanyRemoveMemberRequest: clientCompanyRemoveMemberRequest }, initOverrides);
    }

    /**
     * POST /client-settings/api/team/invitations/{invitationId}
          */
    async resendTeamInvitationRaw(requestParameters: ResendTeamInvitationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['invitationId'] == null) {
            throw new runtime.RequiredError(
                'invitationId',
                'Required parameter "invitationId" was null or undefined when calling resendTeamInvitation().'
            );
        }

        if (requestParameters['resendTeamInvitationRequest'] == null) {
            throw new runtime.RequiredError(
                'resendTeamInvitationRequest',
                'Required parameter "resendTeamInvitationRequest" was null or undefined when calling resendTeamInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/team/invitations/{invitationId}`.replace(`{${"invitationId"}}`, encodeURIComponent(String(requestParameters['invitationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResendTeamInvitationRequestToJSON(requestParameters['resendTeamInvitationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * POST /client-settings/api/team/invitations/{invitationId}
          */
    async resendTeamInvitation(invitationId: string, resendTeamInvitationRequest: ResendTeamInvitationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.resendTeamInvitationRaw({ invitationId: invitationId, resendTeamInvitationRequest: resendTeamInvitationRequest }, initOverrides);
    }

    /**
     * POST /client-settings/api/team/invitations/send
          */
    async sendTeamInvitationRaw(requestParameters: SendTeamInvitationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['clientCompanySendInvitationRequest'] == null) {
            throw new runtime.RequiredError(
                'clientCompanySendInvitationRequest',
                'Required parameter "clientCompanySendInvitationRequest" was null or undefined when calling sendTeamInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/team/invitations/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClientCompanySendInvitationRequestToJSON(requestParameters['clientCompanySendInvitationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * POST /client-settings/api/team/invitations/send
          */
    async sendTeamInvitation(clientCompanySendInvitationRequest: ClientCompanySendInvitationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.sendTeamInvitationRaw({ clientCompanySendInvitationRequest: clientCompanySendInvitationRequest }, initOverrides);
    }

    /**
          */
    async updateTeamSettingsRaw(requestParameters: UpdateTeamSettingsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['clientTeamSettingsUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'clientTeamSettingsUpdateRequest',
                'Required parameter "clientTeamSettingsUpdateRequest" was null or undefined when calling updateTeamSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/team/settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ClientTeamSettingsUpdateRequestToJSON(requestParameters['clientTeamSettingsUpdateRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async updateTeamSettings(clientTeamSettingsUpdateRequest: ClientTeamSettingsUpdateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTeamSettingsRaw({ clientTeamSettingsUpdateRequest: clientTeamSettingsUpdateRequest }, initOverrides);
    }

}
